/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

function DeleteCluster({ name, open, onClose, deleteCluster }) {
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Please confirm deleting the server {name}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please note that deleting is permanent and can't be undone. If
            you're sure you want to delete server {name} please confirm it by
            clicking the "Agree" button.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button data-cy="cancel-delete" onClick={onClose}>
            Disagree
          </Button>
          <Button data-cy="confirm-delete" onClick={deleteCluster}>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DeleteCluster;
